// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
/*   apiUrl: 'http://25.78.150.38:8080',
 */  price: 99,
  commission: 66,
  paymentProcessorFee: 0.3,
  apiUrl: 'https://api.toweringads.com',
  facebookAppId: '7758133740923569',
  /*Dev   SQUARE_ACCESS_TOKEN: 'sandbox-sq0idb-vqC4ijfkF_eH0oNg2HjL_A', */
    SQUARE_ACCESS_TOKEN: 'sq0idp-hM8ApYCdW4l07BBTcnBvwg',//prod

/*  dev SQUARE_LOCATION_ID: 'LKVMHGB03NA2T',
 */    SQUARE_LOCATION_ID: 'LWCKKKEJX71ZX',//prod 

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
